<div class="modal-content">

  <!-- <div class="modal-header">
    <h2>{{ message }}</h2>
  </div> -->
  <div class="modal-body">
    <form [formGroup]="addActionForm">
      <div mat-dialog-title>
        <div mat-dialog-title>
          <div class="d-flex justify-content-between align-items-center">
            <h2>
              {{ editMode ? "Update Action ":"Add Action" }}
            </h2>
            <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
              <i class="fa fa-times" style="color: #fff"></i>
            </button>
          </div>
        </div>
      </div>
      <mat-dialog-content *ngIf="!editMode">
        <div class="content-row-wrap" style="margin-bottom: 20px">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{langObj ? langObj?.RootCause : ('RootCause' | translate)}}</mat-label>
            <input matInput placeholder="Enter Root Cause" formControlName="rootcause" />
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label> {{langObj ? langObj?.Action : ('Action' | translate)}} *</mat-label>
            <input matInput placeholder="Enter Action Name" formControlName="action" />
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>
              Actions Criticality Level *
            </mat-label>
            <mat-select [useInfiniteScroll]="true" formControlName="priorityLevel" [multiple]="false"
              [placeholder]="'Select Level'">
              <mat-option [value]="item.Id" *ngFor="let item of Levels">
                {{ item.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>
              {{langObj ? langObj?.SelectMClassification : ('SelectMClassification' | translate)}}
            </mat-label>
            <mat-select ngxMatSelect #msf1="ngxMatSelect" [displayMember]="'Name'" [valueMember]="'Id'"
              [source]="mClassificationTypes" [useInfiniteScroll]="true" formControlName="mClassification"
              [multiple]="false" [placeholder]="'Select M Classification'">
              <mat-option [value]="item.Id" *ngFor="let item of msf1.filteredSource">
                {{ item.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="radio-wrapper">
            <mat-label>{{langObj ? langObj?.ActionType : ('ActionType' | translate)}} *:</mat-label>
            <mat-radio-group formControlName="actionType" class="radio-group" name="ActionType">
              <mat-radio-button value="Preventive">Preventive</mat-radio-button>
              <mat-radio-button value="Corrective">Corrective</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="imgFlex-Wrapper" style="margin-left: 2vw;">
            <mat-label>{{langObj ? langObj?.ChooseImage : ('ChooseImage' | translate)}}</mat-label>
            <div class="imgflex" style="position: relative">
              <div title="image" style="display: flex">
                <img *ngIf="imagefileUrl" (click)="imageZoomModal()" [src]="imagefileUrl" alt="image" width="60px"
                  height="40px" />
              </div>
              <img *ngIf="imagefileUrl" src="assets/images/delete-icon-x.png" (click)="deleteFile('pic')"
                class="imgabsol delete-icon-x" />
              <button mat-flat-button color="accent" type="button" class="upload" (click)="openFile('pic')">
                <mat-icon>attach_file</mat-icon>
              </button>
              <input type="file" (change)="readFile($event, 'pic')" class="d-none" #imageInput accept="image/*" />
            </div>
          </div>
          <div class="imgFlex-Wrapper" style="margin-right: 1vw;margin-left: 3vw;">
            <mat-label>
              {{langObj ? langObj?.ChooseFile : ('ChooseFile' | translate)}}
            </mat-label>
            <div class="imgflex" style="position: relative">
              <div title="pdf" style="display: flex">
                <a *ngIf="filefileUrl" (click)="downloadPDF()"><img src="assets/images/file_img.png" class="pdfimg"
                    alt="pdf" width="60px" /></a>
              </div>
              <img *ngIf=" filefileUrl" src="assets/images/delete-icon-x.png" (click)="deleteFile('file')"
                class="imgabsol delete-icon-x" />
              <button mat-flat-button color="accent" type="button" class="upload" (click)="openFile('file')"
                [disabled]="addStatus == 'Closed'">
                <mat-icon>attach_file</mat-icon>
              </button>
              <input type="file" (change)="readFile($event, 'file')" class="d-none" #fileInput
                accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" />
            </div>
          </div>

          <!-- will be needed later 
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing" *ngIf="showDepartment">
            <mat-label>{{langObj ? langObj?.seldept : ('seldept' | translate)}}</mat-label>
            <mat-select formControlName="departmentMachine" required>
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'Dept_Desc'" [array]="departmentListMachine"
                (filteredReturn)="filteredDepartmentListMachine = $event"></mat-select-filter>
              <mat-option *ngFor="let departments of filteredDepartmentListMachine" [value]="departments.Dept_Id">
                {{departments.Dept_Desc}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          -->

          <!-- <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{langObj ? langObj?.SelectAssignee : ('SelectAssignee' | translate)}} *</mat-label>

              <mat-select ngxMatSelect #msOwner="ngxMatSelect" [displayMember]="'fullName'" [valueMember]="'employeeCode'"
                [source]="inputData.userList"  formControlName="assignTo" 
                [placeholder]="'Search User'" >
                <mat-option *ngFor="let Owner of inputData.userList" [value]="Owner.employeeCode">
                  {{Owner.fullName}}
                </mat-option>
              </mat-select>
          </mat-form-field> -->

          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{langObj ? langObj?.SelectAssignee : ('SelectAssignee' | translate)}} *</mat-label>

            <mat-select ngxMatSelect #msOwner="ngxMatSelect" [displayMember]="'fullName'" [valueMember]="'employeeCode'"
              [source]="inputData.userList" [useInfiniteScroll]="true" formControlName="assignTo"
              [placeholder]="'SelectUser'" [disabled]="addStatus == 'Closed' || !this.addActionForm.value.action" (selectionChange)="updateAssignmentFlags()">
              <mat-option [value]="Owner.employeeCode" *ngFor="let Owner of msOwner.filteredSource">
                {{Owner.fullName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="inputField" style="margin-top: 15px; width: 22%">
            <nz-date-picker class="calender-input" style="margin-left: 0px !important; width: 100%;height: 54px"
              [nzInputReadOnly]="true" [nzShowTime]="false" [nzFormat]="nzDateFormat"
              [nzDisabledDate]="addGetMinDate('Target')" formControlName="targetDate" [nzDisabled]="
              addStatus === 'Open' ? (addActionForm.value.assignTo ? false : true) : true
            ">
            </nz-date-picker>
            <span class="floating-text">{{langObj ? langObj?.TargetDate : ('TargetDate' | translate)}} *</span>
          </div>
          <div class="inputField" style="margin-top: 15px; width: 22%">
            <nz-date-picker class="calender-input" formControlName="revisedDate" [nzFormat]="nzDateFormat"
              [nzInputReadOnly]="true" style="width: 100%; margin-left: 0px !important;height: 54px"
              [nzDisabledDate]="addGetMinDate('Revised')" [nzDisabled]="
              (addStatus && addStatus == 'Open') ||
              addStatus == 'Complete' ||
              addStatus == 'Closed'
            ">
            </nz-date-picker>
            <span class="floating-text">{{langObj ? langObj?.RevisedDate : ('RevisedDate' | translate)}}</span>
          </div>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>No of Misses</mat-label>
            <input matInput placeholder="Enter NoofMisses" formControlName="NoofMisses" readonly />
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing" [ngClass]="{
                'disabled-input':
                addStatus == 'Closed' ||
                !addActionForm.value.targetDate ||
                addStatus == 'Complete'
            }">
            <mat-label>{{langObj ? langObj?.SelectCompleted : ('SelectCompleted' | translate)}}</mat-label>
            <mat-select formControlName="completed" (selectionChange)="onChangeComplete('add')" [disabled]="
                addStatus == 'Closed' ||
                !addActionForm.value.targetDate ||
                addStatus == 'Complete' ||
                (!this.IsLoggedInUserCreator && !this.IsAssignedToCurrentUser) ||
                (!this.IsAssignedToCreator && !this.IsAssignedToCurrentUser)
              ">
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="p-xl-4 uploadinside upload-image-container" *ngIf="showCompleteFileInput"
            style="width: fit-content">
            <span class="upload-image-text">Complete File</span>
            <input type="file" (change)="completeFile($event)" formControlName="completeFile" class="form-control"
              style="height: 48.31px; width: 219px; margin-top: 8px" />
          </div>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            [ngClass]="{ 'disabled-input': disableVerification }">
            <mat-label>{{langObj ? langObj?.SelectVerfication : ('SelectVerfication' | translate)}}</mat-label>
            <mat-select formControlName="verification" [disabled]="addDisableVerification"
              (selectionChange)="onChangeVerification()">
              <mat-option value="">None</mat-option>
              <mat-option value="Approved">Approved</mat-option>
              <mat-option value="Disapproved">Disapproved</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="p-xl-4 uploadinside upload-image-container" *ngIf="showCloseFileInput" style="width: fit-content">
            <span class="upload-image-text">Close File</span>
            <input type="file" (change)="closeFile($event)" formControlName="closefile" class="form-control"
              style="height: 48.31px; width: 219px; margin-top: 8px" />
          </div>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            [ngClass]="{ 'disabled-input': addDisableNewAssigne }">
            <mat-label>{{langObj ? langObj?.SelectNewAssignee : ('SelectNewAssignee' | translate)}}</mat-label>
            <mat-select [disabled]="addDisableNewAssigne" formControlName="newAssignee">
              <mat-select-filter [placeholder]="'Search User'" [displayMember]="'FullName'" [array]="masterUserList"
                (filteredReturn)="masterUserList = $event">
              </mat-select-filter>
              <mat-option *ngFor="let user of masterUserList" [value]="user.employeeCode">
                {{ user.fullName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}</mat-label>
            <input matInput placeholder="{{langObj ? langObj?.EnterRemarks : ('EnterRemarks' | translate)}}"
              formControlName="remarks" [required]="addActionForm.value.verification === 'Disapproved'" />
          </mat-form-field>
          <button [disabled]="!addActionForm.valid" mat-mini-fab mat-button color="primary" matTooltip="Add Action"
            (click)="addAction()" matTooltipClass="custom-tooltip" matTooltipPosition="above"
            style="margin-left: 20px; margin-top: 20px">
            <i class="fa fa-floppy-o" style="color: #fff"></i>
          </button>
          <button [disabled]="!isResetButtonEnabled()" mat-mini-fab mat-button color="primary" matTooltip="Reset"
            (click)="resetForm()" matTooltipClass="custom-tooltip" matTooltipPosition="above"
            style="margin-left: 20px; margin-top: 20px">
            <i class="fa fa-refresh" style="color: #fff"></i>
          </button>
        </div>
      </mat-dialog-content>

      <mat-dialog-content *ngIf="editMode">
        <div class="content-row-wrap" style="margin-bottom: 20px">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{langObj ? langObj?.RootCause : ('RootCause' | translate)}}</mat-label>
            <input matInput placeholder="Enter Root Cause" formControlName="rootcause" />
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label> {{langObj ? langObj?.Action : ('Action' | translate)}} *</mat-label>
            <input matInput placeholder="Enter Action Name" formControlName="action" />
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>
              Actions Criticality Level *
            </mat-label>
            <mat-select [useInfiniteScroll]="true" formControlName="priorityLevel" [multiple]="false"
              [placeholder]="'Select Level'">
              <mat-option [value]="item.Id" *ngFor="let item of Levels">
                {{ item.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>
              {{langObj ? langObj?.SelectMClassification : ('SelectMClassification' | translate)}}
            </mat-label>
            <mat-select ngxMatSelect #msf1="ngxMatSelect" [displayMember]="'Name'" [valueMember]="'Id'"
              [source]="mClassificationTypes" [useInfiniteScroll]="true" formControlName="mClassification"
              [multiple]="false" [placeholder]="'Select M Classification'">
              <mat-option [value]="item.Id" *ngFor="let item of msf1.filteredSource">
                {{ item.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="radio-wrapper">
            <mat-label>{{langObj ? langObj?.ActionType : ('ActionType' | translate)}} *:</mat-label>
            <mat-radio-group formControlName="actionType" class="radio-group" name="ActionType">
              <mat-radio-button value="Preventive">Preventive</mat-radio-button>
              <mat-radio-button value="Corrective">Corrective</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="imgFlex-Wrapper" style="margin-left: 2vw;">
            <mat-label>{{langObj ? langObj?.ChooseImage : ('ChooseImage' | translate)}}</mat-label>
            <div class="imgflex" style="position: relative">
              <div title="image" style="display: flex">
                <img *ngIf="imagefileUrl" (click)="imageZoomModal()" [src]="imagefileUrl" alt="image" width="60px"
                  height="40px" />
              </div>
              <img *ngIf="imagefileUrl" src="assets/images/delete-icon-x.png" (click)="deleteFile('pic')"
                class="imgabsol delete-icon-x" />
              <button mat-flat-button color="accent" type="button" class="upload" (click)="openFile('pic')">
                <mat-icon>attach_file</mat-icon>
              </button>
              <input type="file" (change)="readFile($event, 'pic')" class="d-none" #imageInput accept="image/*" />
            </div>
          </div>
          <div class="imgFlex-Wrapper" style="margin-right: 1vw;margin-left: 3vw;">
            <mat-label>{{langObj ? langObj?.ChooseFile : ('ChooseFile' | translate)}}</mat-label>
            <div class="imgflex" style="position: relative">
              <div title="pdf" style="display: flex">
                <a *ngIf="filefileUrl" (click)="downloadPDF()"><img src="assets/images/file_img.png" class="pdfimg"
                    alt="pdf" width="60px" /></a>
              </div>
              <img *ngIf="filefileUrl" src="assets/images/delete-icon-x.png" (click)="deleteFile('file')"
                class="imgabsol delete-icon-x" />
              <button mat-flat-button color="accent" type="button" class="upload" (click)="openFile(i, 'file')"
                [disabled]="data.Status == 'Closed'">
                <mat-icon>attach_file</mat-icon>
              </button>
              <input type="file" (change)="readFile($event, 'file')" class="d-none" #fileInput
                accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" />
            </div>
          </div>

          <!-- <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing" *ngIf="showDepartment">
            <mat-label>{{langObj ? langObj?.seldept : ('seldept' | translate)}}</mat-label>
            <mat-select formControlName="departmentMachine" required>
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'Dept_Desc'" [array]="departmentListMachine"
                (filteredReturn)="filteredDepartmentListMachine = $event"></mat-select-filter>
              <mat-option *ngFor="let departments of filteredDepartmentListMachine" [value]="departments.Dept_Id">
                {{departments.Dept_Desc}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->

          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{langObj ? langObj?.SelectAssignee : ('SelectAssignee' | translate)}} *</mat-label>
            <mat-select ngxMatSelect #msOwner="ngxMatSelect" [displayMember]="'fullName'" [valueMember]="'employeeCode'"
              [source]="inputData.userList" formControlName="assignTo" [placeholder]="'Search User'"
              [disabled]="isAssigneeDisabled(data, 'edit')" (selectionChange)="setAssignDate(data)">
              <mat-option *ngFor="let Owner of inputData.userList" [value]="Owner.employeeCode">
                {{Owner.fullName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="inputField" style="margin-top: 15px; width: 22%">
            <nz-date-picker class="calender-input" style="margin-left: 0px !important; width: 100%;height: 54px"
              [nzInputReadOnly]="true" [nzShowTime]="false" [nzFormat]="nzDateFormat" [(ngModel)]="data.TargetDate"
              [nzDisabledDate]="getMinDate('Target')" formControlName="targetDate" [nzDisabled]="
              data.Status === 'Open' ? (data.AssignTo ? false : true) : true
            ">
            </nz-date-picker>
            <span class="floating-text">{{langObj ? langObj?.TargetDate : ('TargetDate' | translate)}} *</span>
          </div>
          <div class="inputField" style="margin-top: 15px; width: 22%">
            <nz-date-picker class="calender-input" formControlName="revisedDate" [nzFormat]="nzDateFormat"
              [nzInputReadOnly]="true" style="width: 100%; margin-left: 0px !important;height: 54px"
              [nzDisabledDate]="getMinDate('Revised')" (ngModelChange)="onRevisedDateChange($event, data)" [nzDisabled]="
              (data.Status != 'InProgress' && data.Status == 'Open') ||
              data.Status == 'Complete' ||
              data.Status == 'Closed'
            ">
            </nz-date-picker>
            <span class="floating-text">{{langObj ? langObj?.RevisedDate : ('RevisedDate' | translate)}}</span>
          </div>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>No of Misses</mat-label>
            <input matInput placeholder="Enter NoofMisses" formControlName="NoofMisses" readonly />
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing" [ngClass]="{
                'disabled-input':
                addStatus == 'Closed' ||
                !addActionForm.value.targetDate ||
                addStatus == 'Complete'
            }">
            <mat-label>{{langObj ? langObj?.SelectCompleted : ('SelectCompleted' | translate)}}</mat-label>
            <mat-select formControlName="completed" (selectionChange)="onChangeComplete('edit')" [disabled]="
                data.Status == 'Closed' ||
                !addActionForm.value.targetDate ||
                data.Status == 'Complete' ||
                (!data.IsLoggedInUserCreator && !data.IsAssignedToCurrentUser) ||
                (!data.IsAssignedToCreator && !data.IsAssignedToCurrentUser)
              ">
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="p-xl-4 uploadinside upload-image-container" *ngIf="showCompleteFileInput"
            style="width: fit-content">
            <span class="upload-image-text">Complete File</span>
            <input type="file" (change)="completeFile($event)" formControlName="completeFile" class="form-control"
              style="height: 48.31px; width: 219px; margin-top: 8px" />
          </div>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            [ngClass]="{ 'disabled-input': disableVerification }">
            <mat-label>{{langObj ? langObj?.SelectVerfication : ('SelectVerfication' | translate)}}</mat-label>
            <mat-select formControlName="verification" [disabled]="addDisableVerification"
              (selectionChange)="onChangeVerification()">
              <mat-option value="">None</mat-option>
              <mat-option value="Approved">Approved</mat-option>
              <mat-option value="Disapproved">Disapproved</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="p-xl-4 uploadinside upload-image-container" *ngIf="showCloseFileInput" style="width: fit-content">
            <span class="upload-image-text">Close File</span>
            <input type="file" (change)="closeFile($event)" formControlName="closefile" class="form-control"
              style="height: 48.31px; width: 219px; margin-top: 8px" />
          </div>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            [ngClass]="{ 'disabled-input': shouldDisableNewAssignee(addActionForm.value.verification) }">
            <mat-label>{{langObj ? langObj?.SelectNewAssignee : ('SelectNewAssignee' | translate)}}</mat-label>
            <mat-select [disabled]="shouldDisableNewAssignee(addActionForm.value.verification)" formControlName="newAssignee">
              <mat-select-filter [placeholder]="'Search User'" [displayMember]="'FullName'" [array]="masterUserList"
                (filteredReturn)="masterUserList = $event">
              </mat-select-filter>
              <mat-option *ngFor="let user of masterUserList" [value]="user.employeeCode">
                {{ user.fullName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}</mat-label>
            <input matInput placeholder="{{langObj ? langObj?.EnterRemarks : ('EnterRemarks' | translate)}}"
              formControlName="remarks" [required]="addActionForm.value.verification === 'Disapproved'" />
          </mat-form-field>
          <button [disabled]="!addActionForm.valid" mat-mini-fab mat-button color="primary" matTooltip="Add Action"
            (click)="updateActionPlan()" matTooltipClass="custom-tooltip" matTooltipPosition="above"
            style="margin-left: 20px; margin-top: 20px">
            <i class="fa fa-pencil" style="color: #fff"></i>
          </button>
          <button [disabled]="!isResetButtonEnabled()" mat-mini-fab mat-button color="primary" matTooltip="Reset"
            (click)="resetForm()" matTooltipClass="custom-tooltip" matTooltipPosition="above"
            style="margin-left: 20px; margin-top: 20px">
            <i class="fa fa-refresh" style="color: #fff"></i>
          </button>
        </div>
      </mat-dialog-content>
    </form>

  </div>
  <div class="modal-footer">
    <button (click)="closeModal()" mat-button color="warn">Close</button>
  </div>
</div>